import { LegalKind } from "@upsquad/shared";
import type { RouteObject } from "react-router";
import { LEGAL_ROUTES } from "@/src/legal/constants/legal-routes";
import PublicLegalPage from "@/src/legal/pages/public-legal-page";

export const legalRoutes: RouteObject = {
	children: [
		{ path: LEGAL_ROUTES.PRIVACY, element: <PublicLegalPage kind={LegalKind.PRIVACY} /> },
		{ path: LEGAL_ROUTES.TERMS_OF_USE, element: <PublicLegalPage kind={LegalKind.TERMS_OF_USE} /> },
	],
};
